import { Record, List, fromJS } from 'immutable';
import _ from 'lodash';

import { AmountCurrencies, CurrencyCode } from 'utils/currencyFormat';

const properties = {
  id: '',
  title: '',
  budget: null,
  categoriesExclude: true,
  categories: List(),
  partneredNonprofits: false,
  nonprofitsExclude: true,
  nonprofits: List(),
  fundraisersExclude: true,
  fundraisers: List(),
  locationsExclude: true,
  locations: List(),
  campaignsExclude: true,
  campaigns: List(),
  paymentMethodsExclude: true,
  paymentMethods: List(),
  createdAt: new Date(),
  startingAt: new Date(),
  endingAt: new Date(),
  matchingPercentage: 100,
  maxDistance: undefined,
  limitPerUser: undefined,
  limitTotal: undefined,
  totalIssued: 0,
  totalIssuedCurrencies: undefined,
  totalContribution: 0,
  totalContributionCurrencies: undefined,
  donationsMatchedCount: 0,
  currencyCode: undefined,
  limitToCurrency: false,
  bypassBudgetLimitPerUser: false,
  priority: undefined,
  appliesToGuests: false,
};

export default class DonationMatchingRule extends Record(properties, 'DonationMatchingRule') {
  public readonly id!: string;

  public readonly title!: string;

  public readonly budget!: string;

  public readonly categories!: List<string>;

  public readonly categoriesExclude!: boolean;

  public readonly matchingPercentage!: number;

  public readonly limitTotal!: number;

  public readonly limitPerUser!: number;

  public readonly currencyCode!: CurrencyCode;

  public readonly totalIssued!: number;

  public readonly totalIssuedCurrencies!: AmountCurrencies;

  public readonly totalContribution!: number;

  public readonly totalContributionCurrencies!: AmountCurrencies;

  public readonly donationsMatchedCount!: number;

  public readonly createdAt!: Date;

  public readonly startingAt!: Date;

  public readonly endingAt!: Date;

  public readonly limitHoursPerUser!: number;

  public readonly nonprofits!: List<string>;

  public readonly partneredNonprofits!: boolean;

  public readonly nonprofitsExclude!: boolean;

  public readonly fundraisers!: List<Record<string, unknown>>;

  public readonly fundraisersExclude!: boolean;

  public readonly locations!: List<string>;

  public readonly locationsExclude!: boolean;

  public readonly campaigns!: List<string>;

  public readonly campaignsExclude!: boolean;

  public readonly paymentMethods!: List<string>;

  public readonly paymentMethodsExclude!: boolean;

  public readonly limitToCurrency!: boolean;

  public readonly bypassBudgetLimitPerUser!: boolean;

  public readonly priority!: number;

  public readonly appliesToGuests!: boolean;

  public readonly maxDistance!: number;

  constructor(values: any = {}) {
    const validValues = _.pick(values, Object.keys(properties));
    super({
      ...validValues,
      categories: fromJS(values.categories || []),
      nonprofits: fromJS(values.nonprofits || []),
      fundraisers: fromJS(values.fundraisers || []),
      locations: fromJS(values.locations || []),
      campaigns: fromJS(values.campaigns || []),
      paymentMethods: fromJS(values.paymentMethods || []),
      createdAt: values.createdAt ? new Date(values.createdAt) : undefined,
      startingAt: values.startingAt ? new Date(values.startingAt) : undefined,
      endingAt: values.endingAt ? new Date(values.endingAt) : undefined,
    });
  }

  toForm() {
    const form = this.toJS();

    if (this.paymentMethods?.includes('DeedCredit')) {
      form.excludeDonationCreditDonations = true;
    } else {
      form.excludeDonationCreditDonations = false;
    }

    return form;
  }

  static fromFormToRequestJson({ excludeDonationCreditDonations, ...form }) {
    return {
      ...form,
      paymentMethodsExclude: true,
      paymentMethods: excludeDonationCreditDonations ? ['DeedCredit'] : [],
    };
  }
}
